"use strict";
/**
 * Skin Report Narrative Types
 *
 * Shared TypeScript interfaces for the Stage 5 narrative layer.
 * These types are consumed by both backend (generation) and frontend (display).
 *
 * NOTE: The backend keeps Zod schemas for runtime validation, but imports
 * these TypeScript types for type safety.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=narrative.js.map